import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { Observable } from "rxjs";
import { IDocumentKeyFilterSource, IKeyValueGroup, ITplArbetsorder } from "../../../models/dtos";
import { ITplDestineringsomradefilterQueryResult, TplDestineringsomradefilterQuery } from "../../../models/queries";
import { TplService } from "../../../services/tpl.service";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-destineringsomrade-filter",
    templateUrl: "./tpl-destineringsomrade-filter.component.html",
    styleUrls: ["./tpl-destineringsomrade-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectorComponent
    ]
})
export class TplDestineringsomradeFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {
    @Input() dataSource: ITplArbetsorder[];
    isLoaded = false;
    options: Observable<IKeyValueGroup[]>;

    private readonly tplService = inject(TplService);

    private data: IDocumentKeyFilterSource[];

    constructor() {
        super("destineringsomrade");
    }

    initDestineringsomraden() {
        if (this.isLoaded || this.dataSource.length === 0) {
            return;
        }

        this.tplService.loadDestineringsomradeFilter(new TplDestineringsomradefilterQuery(this.dataSource))
            .subscribe((result: ITplDestineringsomradefilterQueryResult) => {
                this.data = result.documents;
                this.options = new Observable(ob => {
                    ob.next(result.keys);
                });

                const currentValue = this.value();
                const valid = currentValue.filter(x => result.keys.some(x1 => x1.key === x));
                this.onFilterInit(valid);

                if (this.control.value.length === 0) {
                    this.open = false;
                }
                this.isLoaded = true;
            });
    }

    isActive(): boolean {
        return this.value().length > 0;
    }

    keyFormatter = (item) => (item || {}).key;

    match(item: ITplArbetsorder): boolean {
        const data = this.data.filter(x => x.documentId === item.id);

        if (data.length === 0) {
            return false;
        }

        let found = false;
        data.forEach((x: IDocumentKeyFilterSource) => {
            found = x.keys.some(r => this.control.value.includes(r));
        });

        return found;
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));

        if (this.open) {
            this.initDestineringsomraden();
        }
    }

    selectionChanged($event) {
        this.control.setValue($event);
    }

    value(): number[] {
        return this.control.value;
    }

    valueFormatter = (item) => (item || {}).value;

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFilterInit(state: any): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    protected onFormChange(value: number[]): void {
        this.filterLength = value.length;
    }
}
